import React, { useMemo } from "react";
import queryString from "query-string";
import { useUI } from "../context";

export const Hero = () => {
  const { products, page_settings } = useUI();

  const { product = 1 } = queryString.parse(location.search);

  const productDetail = useMemo(() => {
    return products.find((i) => i.id == product);
  }, [product]);

  return (
    <div className="bg-bg-blue py-6 lg:py-10">
      <div className="container flex flex-col gap-4">
        {productDetail && (
          <a
            href={productDetail.link}
            className="text-text-black text-text-sm underline underline-offset-2"
          >
            {productDetail.title}
          </a>
        )}
        <div className="flex flex-col">
          <h1 className="font-display font-bold text-display-xs lg:text-display-lg text-primary-500">
            {page_settings.hero.title}
          </h1>
          <p className="text-text-sm lg:text-text-md lg:font-medium text-text-black">
            {page_settings.hero.description}
          </p>
        </div>
      </div>
    </div>
  );
};
